module.exports = __webpack_public_path__ + "static/media/egg_tan_img.82782c98.jpg";